import { supabase, run } from './db';
import { callEdgeFunction } from './edge';

/**
 * O assistente de IA está ligado para este laboratório?
 *
 * A flag mora no contrato (`lab_subscriptions`), que a equipe não lê; a
 * função do banco responde só o booleano. Falha de rede vira "desligado":
 * sem servidor o assistente não teria como responder mesmo.
 */
export const assistenteLigado = async (laboratoryId) => {
  if (!laboratoryId) return false;
  try {
    return (await run(supabase.rpc('assistente_ia_ligado', { p_laboratory_id: laboratoryId }))) === true;
  } catch (err) {
    console.warn('[assistente] flag indisponível:', err.message);
    return false;
  }
};

/**
 * Manda a mensagem para a Edge Function e devolve a decisão: o fluxo e o que
 * a pessoa citou. Só online — não enfileira, como as outras Edge Functions.
 */
export const perguntarAoAssistente = async ({ mensagem, historico, contexto }) => {
  const { ok, data } = await callEdgeFunction('assistente', { mensagem, historico, contexto }, { requireSession: true });
  if (!ok) throw new Error(data?.erro || 'Assistente indisponível agora.');
  return data;
};
